<template>
    <header-foot class="header-foot--basic">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </header-foot>
</template>

<script>
import HeaderFoot from "@/sets/styles/headers/header-foot.vue";

export default {
    props: {},
    components: {
        HeaderFoot,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.header-foot--basic{
    background-color: var(--v-grey-lighten5);
    border-bottom: 1px solid var(--v-grey-lighten3);
}
</style>
